import type { TOC } from '@ember/component/template-only';

interface CircleNumberOrCheckmarkSignature {
  Args: {
    number?: string | number;
    shouldDisplayCheckmark?: boolean;
  };
  Element: HTMLDivElement;
}

export default <template>
  <div
    class="flex justify-center border border-solid border-carbon-20 m-3 rounded-full h-[30px] w-[30px]
      {{if @shouldDisplayCheckmark 'bg-cilantro-50'}}"
    ...attributes
  >
    {{#if @shouldDisplayCheckmark}}
      <img class="block m-auto" alt="Completed" src="/assets/images/checkmark-white.svg" />
    {{else}}
      <span class="text-lg text-carbon-20 text-center m-auto w-[30px]">{{@number}}</span>
    {{/if}}
  </div>
</template> satisfies TOC<CircleNumberOrCheckmarkSignature>;
